<template>

    <span class="bemerkungErgaenzenButton" v-if="item.task_ergebnis_id || item.traplinked_report_id">

        <b-button variant="outline-secondary"
                  size="sm"
                  class="ml-1 py-0 px-1"
                  :title="$t('message.ergebnisseTable_bemerkung_ergaenzen')"
                  @click="openModal()">
          <b-icon icon="pencil-square" />
        </b-button>

        <!-- Modal um eine Bemerkung zu ergänzen -->
        <b-modal :id="modalId"
                 :title="$t('message.ergebnisseTable_bemerkung_ergaenzen')"
                 :ok-title="$t('message.default_speichern')"
                 :cancel-title="$t('message.default_abbrechen')"
                 :ok-disabled="!neueBemerkungText"
                 @ok="handleOk">
            <div class="mb-3" v-if="item.bemerkung">
                <strong>{{ $t('message.ergebnisseTable_bemerkung_bisher') }}:</strong>
                <div style="white-space: pre-wrap;">{{ item.bemerkung }}</div>
            </div>
            <b-form-textarea v-model="neueBemerkungText"
                              :placeholder="$t('message.ergebnisseTable_bemerkung_neu')"
                              rows="3" />
        </b-modal>

    </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true

    // Define a new component
    export default {
        name: 'BemerkungErgaenzenButton',
        props: {

            /** Ergebnis-Zeile, deren Bemerkung ergänzt werden soll */
            item: {
                type: Object,
                required: true,
            },
            besuchsbericht_id: {
                type: [Number, String],
                required: false,
            },
            traplinkedbericht_id: {
                type: [Number, String],
                required: false,
            }

        },
        data: function () {
          return {
            /** Text der neuen Ergänzung im Bemerkung-Modal */
            neueBemerkungText: '',
          }
        },
        computed: {

          /** eindeutige Modal-Id, damit mehrere Instanzen dieser Komponente gleichzeitig auf einer Seite funktionieren */
          modalId: function () {
            return 'modal-bemerkung-ergaenzen-' + this._uid
          }

        },
        methods: {

          /** öffnet das Modal um eine Bemerkung zu ergänzen */
          openModal: function () {

            this.neueBemerkungText = ''
            this.$bvModal.show(this.modalId)

          },
          /** OK-Klick im Bemerkung-Modal: Standard-Schließen verhindern, erst nach erfolgreichem Speichern schließen */
          handleOk: function (bvModalEvt) {

            bvModalEvt.preventDefault()
            this.appendBemerkung()

          },
          /** speichert die Ergänzung einer Bemerkung im Datenbroker und aktualisiert die Zeile */
          appendBemerkung: function () {

            if (!this.neueBemerkungText) {
              return
            }

            const url  = process.env.VUE_APP_SERVER_URL + '/datenbroker/appendErgebnisBemerkung'
            const that = this

            this.showSpinner()
            axios({
              method: 'POST',
              url: url,
              params: {
                task_ergebnis_id: this.item.task_ergebnis_id,
                traplinked_report_id: this.item.traplinked_report_id,
                besuchsbericht_id: this.besuchsbericht_id,
                traplinkedbericht_id: this.traplinkedbericht_id,
                bemerkung: this.neueBemerkungText
              }
            }).then(function (response) {

              that.item.bemerkung = response.data.bemerkung
              that.neueBemerkungText = ''
              that.hideSpinner()
              that.$bvModal.hide(that.modalId)

            }).catch(error => {
              console.log(error)
              that.hideSpinner()
              alert(that.$t('message.ergebnisseTable_bemerkung_fehler'))
            })

          }

        } // ende methods

    }

</script>
